import './NavBar.scss';
import Back from '../../../images/back-navbar.png';
import Logo from '../../../images/logo-navbar.png';
import Home from '../../../images/home-navbar.png';
import { useNavigate } from 'react-router-dom';

export const Navbar = ({
  pinned,
  leftButtonIcon = Back,
  leftButtonAction,
  rightButtonIcon = Home,
  rightButtonAction,
  logo = Logo,
  isText,
}) => {
  const navigate = useNavigate();
  if (!leftButtonAction) leftButtonAction = () => navigate(-1);
  if (!rightButtonAction) rightButtonAction = () => navigate('/landing');

  return (
    <div className={`navbar ${pinned ? 'pinned' : ''}`}>
      {leftButtonIcon ? <img src={leftButtonIcon} alt="LeftNavButton" onClick={leftButtonAction} /> : <div className="empty" />}
      <div className="logo">
        {isValidPath(logo) && !isText ? <img className="logo-img" src={logo} alt="Logo" /> : <div className="logo-text">{logo}</div>}
      </div>
      {rightButtonIcon ? <img src={rightButtonIcon} alt="RightNavButton" onClick={rightButtonAction} /> : <div className="empty" />}
    </div>
  );
};

const isValidPath = (text) => {
  if (!text) return false;
  return true;
};
